<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
  <app-hero-section
    height="240px"
    paddingTop="110px"
    opacity=".8"
    [backgroundImage]="`images/${file}/backgrounds/${file}.png`"
    [title]="`images/${file}/${file}.svg`"
    text="resources">
  </app-hero-section>

  <section class="max-w-[1200px] mx-auto px-6 pb-20 pt-2">
    <div class="flex flex-wrap gap-2 justify-center mb-12">
      <button
        type="button"
        (click)="selectCategory(null)"
        [class.bg-white]="selectedCategory() === null"
        [class.text-black]="selectedCategory() === null"
        class="px-4 py-2 rounded-full text-xs border border-white/30 hover:bg-white/10 transition">
        All
      </button>
      @for (c of categories(); track c.slug) {
        <button
          type="button"
          (click)="selectCategory(c.slug)"
          [class.bg-white]="selectedCategory() === c.slug"
          [class.text-black]="selectedCategory() === c.slug"
          class="px-4 py-2 rounded-full text-xs border border-white/30 hover:bg-white/10 transition">
          {{ c.name }}
        </button>
      }
    </div>

    @if (allPosts().length === 0) {
      <p class="text-center text-white/70">Loading…</p>
    } @else {
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        @for (post of visible(); track post.id) {
          <app-blog-card [post]="post"></app-blog-card>
        }
      </div>

      @if (hasMore()) {
        <div class="flex justify-center mt-12">
          <button
            type="button"
            (click)="loadMore()"
            class="px-8 py-3 rounded-full border border-white/30 text-white hover:bg-white/10 transition">
            Load more
          </button>
        </div>
      }
    }
  </section>

  <app-connect></app-connect>
</app-background>
